function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHazzatOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g900",
    transform: "matrix(0.99962926,0,0,1.0003454,5.3723024e-5,-4.0356009e-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4877-2",
    style: {
      fill: "#c2e7eb",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313116px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 4.0788684,0.11240387 5.1830174,1.0389856 M 0.15026915,0.14902097 H 4.0265851 V 1.0756146 h 1.104149 V 6.4483033 H 0.15026915 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g892"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313116px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 0.95658936,4.7103836 H 4.0609269",
    id: "path12824"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313116px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 1.5622001,3.7809948 H 4.6664788",
    id: "path12826"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.313116px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 0.46774538,3.7924038 2.5839595,0.82109839",
    id: "path12828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12830",
    style: {
      fill: "#343434",
      stroke: "#343434",
      strokeWidth: 0.944882,
      strokeLinecap: "square"
    },
    transform: "matrix(0.3102204,-0.02596623,0.02566256,0.31389125,-122.44501,-103.91305)",
    d: "m 372.23471,367.34592 -1.067,-0.9881 -1.067,-0.9881 1.38922,-0.42999 1.38922,-0.43 -0.32222,1.4181 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazzatOn);
export default __webpack_public_path__ + "static/media/hazzat_on.d536d027b372c5390a2f5fd5c363bd4a.svg";
export { ForwardRef as ReactComponent };